import { getStoredIdToken } from "lib/auth";

export async function authenticatedApiRequest(url: string): Promise<Response> {
  const idToken = await getStoredIdToken();

  if (!idToken) {
    return Promise.reject(new Error("could not get token"));
  }

  return fetch(url, {
    headers: makeApiRequestHeaders(idToken),
  });
}

export function makeApiRequestHeaders(
  token?: string,
  headers: Record<string, string> = {}
): Record<string, string> {
  return {
    ...headers,
    ...(token ? { authorization: `Bearer ${token}` } : {}),
    "X-API-VERSION": process.env.NEXT_PUBLIC_API_VERSION,
  };
}
